module.exports = __webpack_public_path__ + "static/15-73eb0515b1df57abd358c3693c8c57f2.jpeg";